import React from 'react';
import { useNavigate } from 'react-router';
import { Dialog, ElevatedButton, TextButton } from '@producer/ui-kit';

import { CrossCircledFilledIcon } from '../../../components/icons/cross-circled-filled.icon';
import { useCurrentMember } from '../../../hooks/use-current-member';

import styles from './past-due-warning.modal.module.scss';
export type PastDueWarningModalProps = {
  onCancel: () => void;
  spaceId: string;
};

export const PastDueWarningModal: React.FC<PastDueWarningModalProps> = ({ onCancel, spaceId }) => {
  const navigate = useNavigate();
  const currentMember = useCurrentMember();

  const handleClick = () => {
    navigate(`/space/${spaceId}/settings/billings`);
    onCancel();
  };

  return (
    <Dialog
      onClose={onCancel}
      actions={[
        <TextButton key="cancel" text="Cancel" onClick={onCancel} />,
        ...(['owner', 'admin'].includes(currentMember?.role || '')
          ? [<ElevatedButton key="upgrade" onClick={handleClick} text="Subscribe" autoFocus />]
          : []),
      ]}
    >
      <div className={styles['container']}>
        <div className={styles['icon']}>
          <CrossCircledFilledIcon />
        </div>

        <h1>Your Subscription Needs Attention</h1>

        <p>
          It looks like your subscription is overdue. You have 30 days to renew it before your
          creative space is temporarily locked. Stay ahead by updating your payment info and keeping
          everything running smoothly.
        </p>
      </div>
    </Dialog>
  );
};
